<div class="recent_news bg_2 ">
    <div class="p-x-20">
        <div class="color_black font_20 weight_700 border_bottom_blue_1">
            <div class="p-bot-10 border_bottom_blue_5 width_fit">
                Recent News
            </div>        
        </div>
    </div> 
    <div class="recent_news_body">
        <div class="dis_flex align_stretch flex_wrap">
            <ng-container *ngFor="let news of data">
                <div class="recent_news_body_item p-top-40 p-x-20">
                    <div class="bg_1 border-radius-20 height_100_per cursor_pointer" (click)="goToNewsDetail(news.slug || news._id)">
                        <img class="recent_news_body_item_img" [src]="news.imgPath" />
                        <div class="p-24 color_black">
                            <div class="font_12 weight_500">
                                <!-- {{news.createdAt | date}} -->
                            </div> 
                            <div class="p-top-8 font_16 weight_600">
                               
                                {{news.title}}
                            </div>                       
                        </div>
                    </div>                
                </div>
            </ng-container>
        </div>    
        <!-- <div class="p-top-40 p-b-60">

        </div>     -->
    </div>   
</div>